import { render, staticRenderFns } from "./settingCooperator.vue?vue&type=template&id=e185b4c8&scoped=true&"
import script from "./settingCooperator.vue?vue&type=script&lang=js&"
export * from "./settingCooperator.vue?vue&type=script&lang=js&"
import style0 from "./settingCooperator.vue?vue&type=style&index=0&id=e185b4c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e185b4c8",
  null
  
)

export default component.exports